import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';

export const formatPhoneNumber = (value: string = ''): string => {
  if (!value || typeof value !== 'string') return '';
  // Try to parse a complete phone number
  const parsed = parsePhoneNumberFromString(value);
  if (parsed) {
    // Format in international format if country code present, else national
    return parsed.countryCallingCode ? parsed.formatInternational() : parsed.formatNational();
  }
  // Fallback to as-you-type formatting for incomplete input
  return new AsYouType('US').input(value);
};
